import { Record as record, Map } from 'immutable';

import { construct, resolve } from '../../helpers/LinkMapper';
import trainTime from '../../lib/TrainTime';

const defaults = {
    reference: null,
    dateTime: null,
    type: null,
    attributes: null
};

class SmartcardJourneyRecord extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(SmartcardJourneyRecord, json, {
            reference: resolve.with(String),
            dateTime: resolve.with(trainTime),
            type: resolve.with(String),
            attributes: resolve.with(Map)
        });
    }

    isJourney () {
        return this.type.match(/^Journey record/);
    }

    isJourneyStart () {
        return this.type === 'Journey record - Check in';
    }

    isJourneyEnd () {
        return this.type === 'Journey record - Check out';
    }

    getLocation () {
        if (this.isJourneyStart()) { return this.attributes.get('Origin'); }
        if (this.isJourneyEnd()) { return this.attributes.get('Destination'); }
        return null;
    }

}

export default SmartcardJourneyRecord;



// WEBPACK FOOTER //
// ./src/records/customer/SmartcardJourneyRecord.js